import React, { useContext, useEffect, useState } from 'react'
import { db, auth } from '../firebase'
import { onSnapshot, collection, query, where, limit, orderBy } from "firebase/firestore"



import Loader from '../component/ui/Visual-utilities/Loader';
import d20 from './PendingQuestions.module.css'

import { HiPlus } from 'react-icons/hi'

import { Link } from 'react-router-dom';
import ListQuestions from '../component/questionsStuff/ListQuestions';
import UserContext from '../store/UserContext';
import { BsWhatsapp } from 'react-icons/bs';
function AnsweredQuestions(props) {
    const userCtx = useContext(UserContext);



    const QuestCollRef = collection(db, 'questions')
    const [questions, setQuestions] = useState([]);
    const [isLoading, setIsLoading] = useState(true);


    //  const playSound = () =>{play();console.log('played');}



    useEffect(() => {
        let isMounted = true;//clean up

        setIsLoading(true);
        try {
            const q = query(QuestCollRef, where("sender_id", "==", auth.currentUser.uid), where("question_status", "==", 'done'), orderBy('createdAt', 'desc'), limit(40));

            const getusers = () => {
                onSnapshot(q,
                    snapshot => {
                        let nmb = 0;
                        // eslint-disable-next-line array-callback-return
                        snapshot.docs.map((docu) => {
                            if (docu.data().question_status === 'done' && docu.data().read === false) nmb++;
                        });
                        userCtx.setUnreadAnswers(nmb);

                        if (isMounted) {
                            setQuestions(snapshot.docs.map((docu) => ({ ...docu.data(), question_id: docu.id })))
                            // playSound();
                            setIsLoading(false);
                        }
                    }
                );
            }
            getusers();
        }
        catch (e) { console.log(e) }

        return () => { isMounted = false };//clean up function call
    }, [])




    

    return (
    <div className='MainSplitContainer' >

<div className={'leftContainer '}>
  


      {isLoading && <Loader />}

    
      <div className={d20.PageheaderText}>Answered:</div>
      {!isLoading && questions.length === 0 && 'no answered questions yet'}
      <ListQuestions data={questions} onClick={() => {}} />
      <div className={d20.addNewQuestion}> <Link to="/ask"><HiPlus size='40' /></Link></div>
     
    </div>


    <div className="rightContainer">
    <div className="not_sign__shape">
              <img className="circle" src="/assets/img/icon/sign/circle.png" alt="img not found"/>
                  <img className="zigzag" src="/assets/img/icon/sign/zigzag.png" alt="img not found"/>
                  <img className="dot" src="/assets/img/icon/sign/dot.png" alt="img not found"/>
                  <img className="flower" src="/assets/img/icon/sign/flower.png" alt="img not found"/> 
                  
                  <div className="center_logo d-flex flex-column justify-content-center2 align-content-center">
                  <img className='logo' src="/assets/img/logo/questa logo.png" alt="img not found"/>
                  <p className=' under_logo text-center'>For any help feel free to reach us out on<a className="" href='https://wa.me/message/EQMDVYMG5NXJK1'><br/><b> 81 184 763<BsWhatsapp /></b> </a></p>
                  </div>

                  
              </div> 
               </div> 
              </div>
  

    




  )
}

export default AnsweredQuestions
